import api, { unwrapList } from './api';
const reportService = {
  getTripsReport:    (p) => api.get('/reports/trips/', { params: p }).then(r => unwrapList(r.data)),
  getFinanceReport:  (p) => api.get('/reports/finance/', { params: p }).then(r => unwrapList(r.data)),
  getDriverReport:   (p) => api.get('/reports/drivers/', { params: p }).then(r => unwrapList(r.data)),
  downloadPDF:       (p) => api.get('/reports/pdf/', { params: p, responseType: 'blob' }),
  downloadExcel:     (p) => api.get('/reports/excel/', { params: p, responseType: 'blob' }),
};
export default reportService;